import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public stats: any[] = [];
    public notices: any[] = [];
    public infoCards: any[] = [];
    public chartData: any[] = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadDashboard();
        await this.service.render();
    }

    public async loadDashboard() {
        let res = await wiz.call("dashboard");
        if (res.code === 200 && res.data) {
            const d = res.data;

            this.stats = [
                { label: '오늘 매출', value: (d.today_amount || 0).toLocaleString(), unit: '원', icon: 'won' },
                { label: '오늘 주문', value: (d.today_count || 0).toLocaleString(), unit: '건', icon: 'order' },
                { label: '등록 상품', value: (d.total_products || 0).toLocaleString(), unit: '건', icon: 'product' },
                { label: '총 회원수', value: (d.total_members || 0).toLocaleString(), unit: '명', icon: 'users' },
            ];

            this.notices = (d.notices || []).map((n: any) => ({
                id: n.id,
                title: n.title,
                date: (n.created || '').substring(0, 10),
                type: '공지'
            }));

            this.infoCards = [
                { label: '재직 사원', value: String(d.total_employees || 0), unit: '명', status: 'active' },
                { label: '총 상품', value: String(d.total_products || 0), unit: '건', status: 'active' },
                { label: '총 회원', value: String(d.total_members || 0), unit: '명', status: 'active' },
                { label: '오늘 주문', value: String(d.today_count || 0), unit: '건', status: d.today_count > 0 ? 'active' : 'normal' },
            ];

            this.chartData = (d.daily_sales || []).map((s: any) => ({
                label: s.label,
                value: s.amount,
                pct: s.pct || 0
            }));
        } else {
            this.stats = [
                { label: '오늘 매출', value: '0', unit: '원', icon: 'won' },
                { label: '오늘 주문', value: '0', unit: '건', icon: 'order' },
                { label: '등록 상품', value: '0', unit: '건', icon: 'product' },
                { label: '총 회원수', value: '0', unit: '명', icon: 'users' },
            ];
            this.notices = [];
            this.infoCards = [];
            this.chartData = [];
        }
    }

    public formatNumber(val: number): string {
        return val.toLocaleString();
    }
}

export default PageDashboardComponent;